import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'
import Slide from '@mui/material/Slide'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { QuestionContainer } from 'layouts/onboarding/QuestionContainer'
import CompletedOnboarding from 'components/CompletedOnboarding'
import { useOnboarding } from '../hooks/useOnboarding'
import Button from '@mui/material/Button'
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const ModalOnboarding = ({
  open = false,
  handleClose,
  modalHeader,
  steps,
  customHandleNext,
}) => {
  const {
    activeStep,
    animate,
    setAnimate,
    userNotification,
    StepComponent,
    stepComponentProps,
    required,
    handleBack,
    handleNext,
    isLastStep,
    isDisabled,
  } = useOnboarding({
    steps,
    updateUrlOnNavigation: false,
    transitionTimeout: 0,
    customHandleNext,
  })

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth={'md'}
      fullWidth={true}
    >
      <DialogTitle
        display={steps[activeStep] === undefined ? 'none' : 'block'}
        sx={{ textAlign: 'center', fontSize: '32px', paddingBottom: '0px' }}
      >
        {modalHeader}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Grid item xs={12} data-testid="modalOnboarding">
          <QuestionContainer
            activeStep={activeStep}
            animate={animate}
            setAnimate={setAnimate}
            userNotification={userNotification}
            StepComponent={
              steps[activeStep] === undefined
                ? CompletedOnboarding
                : StepComponent
            }
            stepComponentProps={stepComponentProps}
            required={required}
            handleBack={handleBack}
            handleNext={handleNext}
            isLastStep={steps[activeStep] === undefined}
            handleCompleteOnboarding={handleClose}
            isDisabled={isDisabled}
          />
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
